export default __webpack_public_path__ + "static/media/ScreenCall_icon.6ee8d339.svg";